import React, { useEffect, useRef, useState } from 'react';
import Layouts from '../layouts/Layouts';
import { getAuthorizationHeader, http } from '../config/http';
import SpinnerGetData from '../components/common/SpinnerGetData';
import { IconCalendar, IconPrinter, IconTrash, IconBuildingStore } from '@tabler/icons-react';
import { Calendar } from 'react-date-range';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import LayoutsKasir from '../layouts/LayoutsKasir';
import LaporanCashflowKasir from './Kasir/LaporanCashflowKasir';
import { DinamicTitle } from '../utils/DinamicTitle';
import CustomLaporanCashflow from './CustomLaporanCashflow';
import useCabang from './features/useCabang';

const getTipeLabel = (tipe) => {
  switch (tipe) {
    case 'pemasukan': return 'Pemasukan';
    case 'tambah-kas': return 'Tambah KAS';
    case 'tarik-kas': return 'Tarik KAS';
    case 'm-banking': return 'M-Banking';
    case 'gaji-karyawan': return 'Gaji Karyawan';
    case 'indihome': return 'Indihome';
    case 'asuransi': return 'Asuransi';
    case 'listrik': return 'Listrik';
    case 'bensin': return 'Bensin';
    case 'parkir': return 'Parkir';
    case 'makan': return 'Makan';
    case 'donasi-santunan': return 'Donasi dan Santunan';
    case 'pengeluaran-lainnya': return 'Pengeluaran Lainnya';
    default: return tipe;
  }
};

const LaporanCashflow = () => {
  DinamicTitle('Laporan Harian');
  const navigate = useNavigate();
  const role = localStorage.getItem('role');
  const { cabang } = useCabang();
  const [selectedCabang, setSelectedCabang] = useState('');
  const [tglFilter, setTglFilter] = useState(null);
  const [laporanHarian, setLaporanHarian] = useState([]);
  const [trxMbanking, setTrxMbanking] = useState(0);
  const [pengeluaran, setPengeluaran] = useState(0);
  const [pemasukan, setPemasukan] = useState(0);
  const [trxLuar, setTrxLuar] = useState([]);
  const [loadingLaporanHarian, setLoadingLaporanHarian] = useState(false);
  var jumlah = 0;
  const getPengeluaranHarian = async () => {
    // Admin harus pilih cabang dulu
    if (role === 'admin' && !selectedCabang) {
      setLaporanHarian([]);
      setTrxLuar([]);
      return;
    }
    setLoadingLaporanHarian(true);
    const params = [];
    if (tglFilter !== null) params.push(`tanggal=${tglFilter}`);
    if (role === 'admin' && selectedCabang) {
      params.push(`cabang=${selectedCabang}`);
      params.push(`cabang_id=${selectedCabang}`); // Fallback for some endpoints
    }
    const query = params.length > 0 ? `?${params.join('&')}` : '';
    await http
      .get(`/laporan_harian${query}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setLaporanHarian(res.data.data);
        setTrxLuar(res.data.data.cashflow);
        setTrxMbanking(res.data.data.summary.total_m_banking);
        setPengeluaran(res.data.data.summary.total_pengeluaran);
        setPemasukan(res.data.data.summary.total_pemasukan);
      })
      .catch((err) => {
        if (!err.response) {
          return null;
        } else if (err.response.status === 403) {
          if (role !== 'admin') {
            navigate('/login');
          } else {
            console.error('Admin forbidden access to laporan_harian');
          }
        }
      });
    setLoadingLaporanHarian(false);
  };

  useEffect(() => {
    getPengeluaranHarian();
  }, [tglFilter, selectedCabang]);

  function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // console.log('tglFilter :', tglFilter);
  function handleSelect(date) {
    // console.log(`date`, date)
    const tgl = moment(date).format('DD-MM-YYYY');

    setTglFilter(tgl);
  }

  function roundNumber(number) {
    return number?.toFixed(3);
  }

  const [barangTerkini, setBarangTerkini] = useState([]);
  const [totalBeratBarangTerkini, setTotalBeratBarangTerkini] = useState(0);
  const [totalHargaBarangTerkini, setTotalHargaBarangTerkini] = useState(0);
  const [totalBijiBarangTerkini, setTotalBijiBarangTerkini] = useState(0);
  const [loadingBarangTerkini, setLoadingBarangTerkini] = useState(false);

  const [customBerat, setCustomBerat] = useState('');
  const [customNama, setCustomNama] = useState('');
  const [customArray, setCustomArray] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const handleDelete = (indexToDelete) => {
    const newArray = customArray.filter((_, index) => index !== indexToDelete);
    setCustomArray(newArray);
  };

  const dropdown = useRef(null);
  const trigger = useRef(null);

  function submitCustom(e) {
    if (customBerat !== '' && customNama !== '') {
      const newItem = { berat: customBerat, nama: customNama };
      setCustomArray((prevArray) => [...prevArray, newItem]);
      setCustomBerat('');
      setCustomNama('');
    } else {
      console.log('Pastikan nilai customBerat dan customNama tidak kosong.');
    }
  }
  // const totalBerat = customArray.reduce((total, item) => total + parseFloat(item.berat), 0).toFixed(3);
  const totalBerat = parseFloat(customArray.reduce((total, item) => total + parseFloat(item.berat), 0)).toFixed(3);
  const hasil = parseFloat(totalBeratBarangTerkini).toFixed(3) + totalBerat;

  // console.log('hasil : ', totalBerat, 'data : ', hasil);

  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdownOpen || dropdown.current.contains(target) || trigger.current.contains(target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener('click', clickHandler);
    return () => document.removeEventListener('click', clickHandler);
  });

  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return;
      setDropdownOpen(false);
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  });

  async function getBarangTerkini() {
    const id_brankas = localStorage.getItem('id_brankas');
    const cabangId = role === 'admin' ? selectedCabang : id_brankas;

    // Admin harus pilih cabang dulu
    if (role === 'admin' && !selectedCabang) {
      setBarangTerkini([]);
      return;
    }

    setLoadingBarangTerkini(true);
    await http
      .get(`/summary/item_terkini?cabang=${cabangId}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setTotalBijiBarangTerkini(res.data.total_item);
        setTotalBeratBarangTerkini(res.data.total_berat);
        setTotalHargaBarangTerkini(res.data.total_modal);
        setBarangTerkini(res.data.data);
      })
      .catch((err) => {
        if (!err.response) {
          return null;
        } else if (err.response.status === 401 || (err.response.status === 403 && role !== 'admin')) {
          navigate('/login');
        }
      });
    setLoadingBarangTerkini(false);
  }
  useEffect(() => {
    getBarangTerkini();
  }, [selectedCabang]);

  if (role === 'kasir') {
    return (
      <LayoutsKasir>
        <LaporanCashflowKasir
          laporanHarian={laporanHarian}
          loadingLaporanHarian={loadingLaporanHarian}
          numberWithCommas={numberWithCommas}
          roundNumber={roundNumber}
          trxLuar={trxLuar}
          tglFilter={tglFilter}
          handleSelect={handleSelect}
        // barangTerkini={barangTerkini}
        // loadingBarangTerkini={loadingBarangTerkini}
        // totalBeratBarangTerkini={totalBeratBarangTerkini}
        // totalBijiBarangTerkini={totalBijiBarangTerkini}
        // totalHargaBarangTerkini={totalHargaBarangTerkini}
        />
      </LayoutsKasir>
    );
  } else {
    return (
      <Layouts
      // title={'Laporan Buku'}
      >
        <div className="sm:mx-8 mx-2 p-2 mt-2 ">
          {/* Filter Cabang untuk Admin */}
          {role === 'admin' && (
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-4 rounded-lg mb-3">
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 text-amber-700 dark:text-amber-400">
                  <IconBuildingStore className="w-5 h-5" />
                  <span className="font-semibold text-sm uppercase tracking-wide">Pilih Cabang / Toko</span>
                </div>
                <select
                  value={selectedCabang}
                  onChange={(e) => setSelectedCabang(e.target.value)}
                  className="flex-1 max-w-xs px-3 py-2 rounded-lg border border-amber-200 dark:border-slate-700 bg-amber-50/50 dark:bg-slate-800 text-slate-800 dark:text-slate-200 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-amber-400/50 focus:border-amber-400 transition-all cursor-pointer"
                >
                  <option value="">-- Pilih Cabang --</option>
                  {cabang
                    .filter((cb) => !cb.nama_cabang.toLowerCase().includes('brankas'))
                    .map((cb) => (
                      <option key={cb.id} value={cb.id}>{cb.nama_cabang}</option>
                    ))}
                </select>
              </div>
            </div>
          )}

          {/* Pesan jika admin belum pilih cabang */}
          {role === 'admin' && !selectedCabang ? (
            <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-8 rounded-lg text-center">
              <IconBuildingStore className="w-12 h-12 mx-auto mb-3 text-amber-400/60" />
              <p className="text-slate-500 dark:text-slate-400 font-medium">Silakan pilih cabang/toko terlebih dahulu untuk melihat laporan cashflow.</p>
            </div>
          ) : (
            <>
              <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 shadow p-2 print:border print:p-2 rounded-lg">
                <div className="mb-3 flex justify-between items-center px-4 py-2 bg-orange-500/30 dark:bg-orange-950/20 rounded-lg">
                  <div className="font-bold uppercase text-lg text-slate-900 dark:text-slate-100">
                    Laporan Buku Tanggal {laporanHarian.tanggal} {!tglFilter === null && tglFilter}
                  </div>
                  <div className='gap-2 flex'>
                    <div className="dropdown dropdown-end">
                      <label
                        tabIndex={0}
                        className="bg-orange-500 p-1 flex items-center text-white hover:bg-orange-600 cursor-pointer rounded-md"
                      >
                        <IconCalendar />
                      </label>
                      <div tabIndex={0} className="dropdown-content menu p-2 shadow-xl bg-white dark:bg-slate-800 rounded-xl border dark:border-slate-700 -left-72 w-52 z-50">
                        <Calendar date={new Date()} onChange={handleSelect} />
                      </div>
                    </div>
                  </div>
                </div>
                {loadingLaporanHarian ? (
                  <SpinnerGetData />
                ) : (
                  <>
                    {laporanHarian === undefined ? (
                      <div></div>
                    ) : (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-slate-900 dark:border-slate-700 text-sm print:text-[11px]">
                          <tbody className="text-slate-800 dark:text-slate-200">
                            {/* KAS */}
                            <tr className="border-b border-slate-900 dark:border-slate-700">
                              <td className="w-1/3 border-r border-slate-900 dark:border-slate-700 font-bold px-3 py-2 text-xl md:text-2xl align-top">
                                KAS
                              </td>
                              <td className="px-3 py-2 align-top">
                                <span className="text-xl md:text-2xl font-bold">
                                  Rp. {numberWithCommas(laporanHarian.kas)}
                                </span>
                              </td>
                            </tr>

                            {/* PEMBELIAN */}
                            <tr className="border-b border-slate-900 dark:border-slate-700 align-top">
                              <td className="w-1/3 border-r border-slate-900 dark:border-slate-700 font-semibold px-3 py-2 text-md md:text-lg">
                                PEMBELIAN
                              </td>
                              <td className="px-3 py-2">
                                {laporanHarian.pembelian?.total_harga === 0 ? (
                                  <div className="italic text-slate-500">Data Kosong</div>
                                ) : (
                                  <>
                                    <div className="font-bold text-lg mb-2 text-slate-900 dark:text-slate-100">
                                      Rp. {numberWithCommas(laporanHarian?.pembelian?.total_harga)} /{' '}
                                      {roundNumber(laporanHarian?.pembelian?.total_berat)} gram / RTT.{' '}
                                      {numberWithCommas(Math.round(laporanHarian?.pembelian?.rata_rata))}
                                    </div>
                                    {laporanHarian.pembelian?.items !== undefined && (
                                      <div className="space-y-1">
                                        {laporanHarian.pembelian?.items?.map((itp, i) => (
                                          <div key={i} className="text-sm">
                                            <span className="text-red-500 font-bold">*</span> {itp.karat} karat :{' '}
                                            {itp.total_berat} gram / Rp.
                                            {numberWithCommas(itp.total_harga)} / RTT.
                                            {numberWithCommas(Math.round(itp.rata_rata))}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>

                            {/* PENJUALAN */}
                            <tr className="border-b border-slate-900 dark:border-slate-700 align-top">
                              <td className="w-1/3 border-r border-slate-900 dark:border-slate-700 font-semibold px-3 py-2 text-md md:text-lg">
                                PENJUALAN
                              </td>
                              <td className="px-3 py-2">
                                {laporanHarian.penjualan?.total_harga === 0 ? (
                                  <div className="italic text-slate-500">Data Kosong</div>
                                ) : (
                                  <>
                                    <div className="font-bold text-lg mb-2 text-slate-900 dark:text-slate-100">
                                      Rp. {numberWithCommas(laporanHarian?.penjualan?.total_harga)} /{' '}
                                      {roundNumber(laporanHarian?.penjualan?.total_berat)} gram / RTT.{' '}
                                      {numberWithCommas(Math.round(laporanHarian?.penjualan?.rata_rata))}
                                    </div>
                                    {laporanHarian.penjualan?.items !== undefined && (
                                      <div className="space-y-1">
                                        {laporanHarian.penjualan?.items?.map((itp, i) => (
                                          <div key={i} className="text-sm">
                                            <span className="text-red-500 font-bold">*</span> {itp.karat} karat :{' '}
                                            {itp.total_item} biji / {itp.total_berat} gram / Rp.
                                            {numberWithCommas(itp.total_harga)} / RTT.{' '}
                                            {numberWithCommas(Math.round(itp.rata_rata, 1))}
                                          </div>
                                        ))}
                                      </div>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>

                            {/* LUAR TRANSAKSI */}
                            <tr className="border-b border-slate-900 dark:border-slate-700 align-top">
                              <td className="w-1/3 border-r border-slate-900 dark:border-slate-700 font-semibold px-3 py-2 text-md md:text-lg">
                                LUAR TRANSAKSI<br /> PENGELUARAN PEMASUKAN
                              </td>
                              <td className="px-3 py-2 text-slate-800 dark:text-slate-300">
                                <div className="mt-1 text-sm space-y-1">
                                  {trxLuar.map((res, i) => (
                                    <div key={i} className="mb-1">
                                      <span className="text-red-500 font-bold">*</span> {getTipeLabel(res.tipe)} /
                                      <span className="">
                                        {' '}
                                        <span className='font-bold'>Rp.
                                          {numberWithCommas(res.nominal)}</span> {(res.keterangan === '' || res.keterangan === '.' || res.keterangan === '-' || res.keterangan === null) ? '' : `(${res.keterangan})`}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </td>
                            </tr>

                            {/* SISA KAS */}
                            <tr className="align-top">
                              <td className="w-1/3 border-r border-slate-900 dark:border-slate-700 font-bold px-3 py-2 text-xl md:text-2xl">
                                SISA KAS
                              </td>
                              <td className="px-3 py-2">
                                <span className="font-bold text-xl md:text-2xl text-slate-900 dark:text-slate-100">
                                  Rp. {numberWithCommas(laporanHarian.sisa_kas)}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="bg-white dark:bg-slate-900 border dark:border-slate-800 rounded-lg shadow mt-3  p-2 overflow-x-auto">
                <div>
                  {loadingBarangTerkini ? (
                    <SpinnerGetData />
                  ) : (
                    <>
                      <div className="px-4 pt-2 pb-1 flex items-center justify-between font-bold uppercase text-lg text-slate-900 dark:text-slate-100 bg-orange-500/30 dark:bg-orange-950/20 rounded-lg">
                        <div>Barang Brankas</div>
                        <div>
                          <CustomLaporanCashflow
                            customBerat={customBerat}
                            customNama={customNama}
                            submitCustom={submitCustom}
                            setCustomBerat={setCustomBerat}
                            dropdown={dropdown}
                            dropdownOpen={dropdownOpen}
                            setDropdownOpen={setDropdownOpen}
                            trigger={trigger}
                            setCustomNama={setCustomNama}
                          />
                        </div>
                      </div>
                      <div className="p-1">
                        <table className="w-full border border-slate-900 dark:border-slate-700 text-sm text-left  overflow-hidden">
                          <thead className="bg-slate-100 dark:bg-slate-800 text-slate-800 dark:text-slate-100">
                            <tr className="border border-slate-900 dark:border-slate-700 text-lg">
                              <th className="px-2 py-1">No</th>
                              <th className="px-2 py-1">Kategori</th>
                              <th className="px-2 py-1 text-center">Biji</th>
                              <th className="px-2 py-1 text-center">Berat</th>
                              <th className="px-2 py-1 text-right">Modal</th>
                            </tr>
                          </thead>
                          <tbody className="text-slate-800 dark:text-slate-200">
                            {barangTerkini.map((bt, index) => (
                              <tr key={index} className="border border-slate-900 dark:border-slate-700 text-lg">
                                <td className="px-2 py-1">{index + 1}.</td>
                                <td className="px-2 py-1">{bt.kategori}</td>
                                <td className="px-2 py-1 text-center">{bt.jumlah_item_terkini}</td>
                                <td className="px-2 py-1 text-center">{bt.total_berat_terkini}</td>
                                <td className="px-2 py-1 text-right">Rp. {numberWithCommas(bt.total_modal_terkini)}</td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colSpan={5}><hr className="h-[2px] bg-slate-900 dark:bg-slate-600 border-none" /></td>
                            </tr>
                            <tr className="border border-slate-900 dark:border-slate-700 text-lg text-slate-800 dark:text-slate-100">
                              <th></th>
                              <th className="px-2 py-1">Jumlah</th>
                              <th className="px-2 py-1 text-center"><span className="text-red-600 dark:text-red-500 text-lg font-semibold">{totalBijiBarangTerkini} </span> biji</th>
                              <th className="px-2 py-1 text-center"><span className="text-red-600 dark:text-red-500 text-lg font-semibold">{totalBeratBarangTerkini} </span> gram</th>
                              <th className="px-2 py-1 text-right text-red-600 dark:text-red-500 font-semibold">Rp.{' '}
                                <span className="text-lg">
                                  {numberWithCommas(totalHargaBarangTerkini === undefined ? '0' : totalHargaBarangTerkini)}
                                </span>{' '}</th>
                            </tr>
                            <tr>
                              <td colSpan={5}><hr className="h-[2px] bg-slate-900 dark:bg-slate-600 border-none" /></td>
                            </tr>
                          </tfoot>
                        </table>

                        {customArray.length ?
                          <div className="mt-2 text-slate-800 dark:text-slate-200">
                            <table className="w-full text-sm text-left overflow-hidden">
                              <tbody>
                                {customArray.map((ca, index) => {
                                  jumlah = jumlah + parseFloat(ca.berat);
                                  return (<tr key={index} className="border border-slate-900 dark:border-slate-700 text-lg">
                                    <td></td>
                                    <td></td>
                                    <td style={{ 'width': '44%' }} className="px-2 py-1">{ca?.nama}</td>
                                    <td style={{ 'textAlign': 'left' }} className="px-2 py-1">
                                      <span>
                                        {ca?.berat} gram
                                      </span>
                                    </td>
                                    <td className="px-2 py-1 text-right">
                                      <button onClick={() => handleDelete(index)}>
                                        <IconTrash className="w-5 h-5 text-red-500 stroke-1" />
                                      </button>
                                    </td>
                                  </tr>)
                                })}
                              </tbody>
                              <tfoot className="text-slate-800 dark:text-slate-100">
                                <tr className="border border-slate-900 dark:border-slate-700 text-lg">
                                  <th></th>
                                  <th></th>
                                  <th className="px-2 py-1">Total</th>
                                  <th className="px-2 py-1 text-center"><span className="text-red-600 dark:text-red-500 text-lg font-semibold">{parseFloat(totalBeratBarangTerkini) + parseFloat(jumlah)} </span> gram</th>
                                  <th></th>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                          : ''}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </Layouts>
    );
  }
};

export default LaporanCashflow;
